export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

type ErrorPayload = {
  detail?: string | {
    message?: string;
    errors?: unknown;
  };
};

export function errorMessage(payload: ErrorPayload): string {
  if (typeof payload.detail === "string") return payload.detail;
  const message = payload.detail?.message ?? "Falha inesperada";
  const errors = Array.isArray(payload.detail?.errors)
    ? payload.detail.errors.filter((item): item is string => typeof item === "string")
    : [];
  return errors.length ? `${message}:\n${errors.join("\n")}` : message;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "include" });
  if (!response.ok) {
    const payload: ErrorPayload = await response.json().catch(() => ({ detail: "Falha inesperada" }));
    throw new ApiError(response.status, errorMessage(payload));
  }
  return response.json() as Promise<T>;
}

export const formatCnpj = (cnpj: string) => cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
export const formatDate = (value: string | null) => value ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value)) : "—";
